import React, { createContext } from "react";
import { useQuery } from "react-query";
import { AUTH } from "../config/apiConfig";
import axios from "../config/axiosInstance";

const ApplicationContext = createContext();

/*
  Quem está logado.

  O usuário vem de GET /me, não de decodificar o JWT no navegador. A diferença
  importa: o token carrega uma CÓPIA do staff feita no login, então um papel
  rebaixado ou um acesso desativado continuariam valendo na tela por até um
  dia. O /me relê do banco — a mesma fonte que o servidor usa para decidir o
  que a pessoa pode fazer.
*/
const PermissionProvider = ({ children }) => {
  const hasToken = Boolean(localStorage.getItem("token"));

  const {
    data: user,
    isLoading,
    error,
  } = useQuery(
    ["staff", "me"],
    async () => {
      const { data } = await axios.get(AUTH.ME);
      return data.data;
    },
    {
      enabled: hasToken,
      retry: false,
      // Papel e carteira mudam raramente, e cada tela depende deles para
      // desenhar: revalidar a cada 4 minutos (o default global) seria uma
      // chamada por nada.
      refetchInterval: false,
      staleTime: 5 * 60 * 1000,
    }
  );

  /*
    Enquanto não há usuário carregado, o papel assumido é o RESTRITO
    (ACCOUNT_MANAGER). Assumir ADMIN faria o menu e os botões de ação
    piscarem na tela de quem não pode usá-los — e o servidor recusaria o
    clique depois, o que é pior do que nunca ter oferecido.
  */
  const role = user?.role || "ACCOUNT_MANAGER";

  return (
    <ApplicationContext.Provider
      value={{
        user,
        role,
        isAdmin: role === "ADMIN",
        isLoadingUser: hasToken && isLoading,
        userError: error,
      }}
    >
      {children}
    </ApplicationContext.Provider>
  );
};

const useApplication = () => React.useContext(ApplicationContext);

export { PermissionProvider, useApplication };
